import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import LabelText from '../../LabelText';
import CheckboxInput from './Input';

const CBOW = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const {form_component, checkedValues, setCheckedValues} = props;
	const {fieldname, option_display, options, has_other_option, other_option_label, required, limit_option_select, max_options} = form_component;

	const onClick = (e) => {
		const payload = {
			open: true,
			checkedValues: checkedValues,
			form_component: form_component
		};

		dispatch({type: 'SET_CBMODAL_DATA', payload: payload});

		setTimeout(() => {
			$("#cb-modal").modal('show');
		}, 0);
	}

	return (
		<div className={`flex-grow-1 form-group ${required ? 'required' : ''}`}>
			<LabelText
				lang={props.lang}
				form_component={form_component}
			/>
			<div className=" bg-white text-start w-100 p-3 rounded cursor-pointer r_nolink" onClick={onClick}>
				<div className="d-flex justify-content-between align-items-center w-100 border-light border-bottom border-bottom-dashed pb-3">
					<p className="mb-0">{t('已選擇')} <span className="selected-count">{checkedValues.length}</span>
						{/* {limit_option_select && (
							<span className="select-limit"><span className="mx-1">/ {max_options}</span></span>
						)} */}
					</p>
					<p className="mb-0 d-flex gap-1 align-items-center text-hover-primary text-gray-600">
						<span className="toggleText  ">{t('點我選擇')}
					   
						</span>
						<svg
							width="24px"
							height="24px"
							viewBox="0 0 512 512"
							style={{enableBackground: 'new 0 0 512 512'}}
						>
							<g>
								<g>
									<g>
										<path
											fill="currentcolor"
											d="M400,0H112C50.144,0,0,50.144,0,112v288c0,61.856,50.144,112,112,112h288c61.856,0,112-50.144,112-112V112 C512,50.144,461.856,0,400,0z M480,400c0,44.183-35.817,80-80,80H112c-44.183,0-80-35.817-80-80V112c0-44.183,35.817-80,80-80 h288c44.183,0,80,35.817,80,80V400z"
										/>
										<path
											fill="currentcolor"
											d="M160,112h-32c-8.837,0-16,7.163-16,16v32c0,8.837,7.163,16,16,16h32c8.837,0,16-7.163,16-16v-32 C176,119.163,168.837,112,160,112z"
										/>
										<path
											fill="currentcolor"
											d="M160,224h-32c-8.837,0-16,7.163-16,16v32c0,8.837,7.163,16,16,16h32c8.837,0,16-7.163,16-16v-32 C176,231.163,168.837,224,160,224z"
										/>
										<path
											fill="currentcolor"
											d="M160,336h-32c-8.837,0-16,7.163-16,16v32c0,8.837,7.163,16,16,16h32c8.837,0,16-7.163,16-16v-32 C176,343.163,168.837,336,160,336z"
										/>
										<rect fill="currentcolor" x="208" y="128" width="192" height="32" />
										<rect fill="currentcolor" x="208" y="240" width="192" height="32" />
										<rect fill="currentcolor" x="208" y="352" width="192" height="32" />
									</g>
								</g>
							</g>
						</svg>
					</p>
				</div>
				<div className={`label_box label-modal ${option_display === '1R1O' ? 'label-full' : 'label-50'}`}>
					{(() => {
						const components = [];

						options.map((option, index) => {
							//if (checkedValues.indexOf(option.value) >= 0) {
								components.push(
									<CheckboxInput
										key={`input-${index}`}
										lang={props.lang}
										form_component={form_component}
										option={option}
										checkedValues={checkedValues}
									/>
								);
							//}
						});

						if (has_other_option) {
							//if (checkedValues.indexOf('other') >= 0) {
								components.push(
									<CheckboxInput
										key={`input-other`}
										lang={props.lang}
										form_component={form_component}
										option={{
											label: other_option_label,
											value: 'other'
										}}
										checkedValues={checkedValues}
									/>
								);
							//}
						}

						return components;
					})()}
				</div>
			</div>
		</div>
	);
}

export default CBOW;